module.exports = __webpack_public_path__ + "media/coffee-preferences/cream_and_sugar_high-fa0ce8d5.png";